module.exports = __webpack_public_path__ + "img/warning-1.5ec39662.png";